import { MapPin, Clock, ShieldCheck } from "lucide-react";
import ContactForm from "@/components/ContactForm";

const POINTS = [
  {
    icon: MapPin,
    title: "Local & Remote Coverage",
    desc: "On-site visits for homes and workplaces in our local grid, plus secure remote sessions anywhere.",
  },
  {
    icon: Clock,
    title: "Same-Day Response",
    desc: "Fast same-day help is our standard — dispatch target under 2 hours for local tickets.",
  },
  {
    icon: ShieldCheck,
    title: "Independent & Upfront",
    desc: "Not affiliated with Canon Inc. Clear diagnostics and quotes before any repair proceeds.",
  },
];

export default function ContactPage() {
  return (
    <main data-testid="contact-page">
      <section className="py-16 px-6 max-w-6xl mx-auto">
        <span className="px-2 py-0.5 bg-poster-accent text-white text-[11px] font-mono-lbl uppercase tracking-wider font-bold">
          Fast Action Desk
        </span>
        <h1 className="font-poster text-[clamp(40px,6vw,80px)] uppercase tracking-tight text-poster-ink leading-[0.95] my-4">
          <span className="ln"><span>Request same-day</span></span>
          <span className="ln"><span className="text-poster-accent">printer support.</span></span>
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mt-10 items-start">
          <div className="lg:col-span-7 bg-white border-2 border-poster-ink shadow-[8px_8px_0px_#0F172A] p-8 md:p-10">
            <div className="mb-6 p-3 bg-sky-50 border border-sky-200 flex items-center gap-3">
              <div className="w-8 h-8 bg-poster-accent text-white flex items-center justify-center font-poster text-base shrink-0">
                !
              </div>
              <p className="text-xs text-sky-800 font-medium">
                Clear diagnostics with no hidden charges. Upfront quotes before repairs proceed.
              </p>
            </div>
            <ContactForm />
          </div>

          <div className="lg:col-span-5 space-y-6">
            {POINTS.map((p) => (
              <div
                key={p.title}
                data-testid={`contact-point-${p.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="bg-white border-2 border-poster-ink shadow-[4px_4px_0px_#0F172A] p-6"
              >
                <p.icon className="text-poster-accent" size={26} strokeWidth={2.2} />
                <h3 className="font-poster text-xl uppercase text-poster-ink mt-3">{p.title}</h3>
                <p className="text-xs text-slate-600 mt-2 leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
